module.exports = __webpack_public_path__ + "img/xiaoman7.f4b3dda7.png";